<template>
  <div class="container-fluid">

    <div class="container-fluid bg-base-green trees-bg">
      <div class="row pt-5 pb-5">
        <div class="col-12">
          <h1 class="title text-center">{{$t('involucrados_h1')}}</h1>
          <div class="intro">{{$t('involucrados_intro')}}</div>
        </div>      
      </div>
    </div>
    

    <div class="container mt-5">
      <div class="row filter-block justify-content-center">
        <div class="col-12 col-md-4">
          <p>{{$t('involucrados_buscar')}}</p>
        </div>
        <div class="col-12 col-md-8">
          <BuscadorMenu :dataset="dataset"></BuscadorMenu>
        </div>
      </div>
      <div class="row filter-block mt-5 mb-5">
        <div class="col-4 col-md-5 involucrado-filter">
          <b-tabs content-class="mt-3">
            <b-tab :title="$t('involucrados_lista')">
              <b-form-group>
                <template #label>
                  <b-form-checkbox
                    class="check"
                    aria-describedby="actores_field"
                    aria-controls="actores_field"
                    @change="toggleAll"
                  >

                    {{ filters.length > 0 ? $t('involucrados_select') : $t('involucrados_select')}}
                  </b-form-checkbox>
                </template>
                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group class="check" v-model="filterBy" :options="filters" :aria-describedby="ariaDescribedby" name="actores_field">                                                           
                  </b-form-checkbox-group>  
                </template>
              </b-form-group>
              
            </b-tab>
          </b-tabs>      
        </div>
        <div class="col-3 col-md-4 involucrado-filter">
          <b-tabs content-class="mt-3">
            <b-tab :title="$t('involucrados_modalidad')">
              <b-form-group>
                <template #label>
                  <b-form-checkbox
                  class="check"
                  aria-describedby="modalidad_selected"
                  aria-controls="modalidad_selected"
                  @change="toggleModalidad"
                  >
                  {{ modalidadSelected.length  > 0 ? $t('involucrados_select_modalidad') : $t('involucrados_select_modalidad')  }}
                  </b-form-checkbox>
                </template>
                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group  v-model="modalidadSelected" :options="modalidad" :aria-describedby="ariaDescribedby"
                    name="modalidad_selected"
                    class="check"
                  ></b-form-checkbox-group>
                </template>                
              </b-form-group>            
            </b-tab>
          </b-tabs>
        </div>
        
        <div class="col-4 col-md-3 involucrado-filter">
          <b-tabs content-class="mt-3">
            <b-tab :title="$t('involucrados_region')">
              <b-form-group>
                <template #label>
                  <b-form-checkbox
                    class="check"
                    aria-describedby="departamento_selected"
                    aria-controls="departamento_selected"
                    @change="toggleDep"
                    >
                    {{  departamentoSelected.length > 0 ? $t('involucrados_select_region') : $t('involucrados_select_region') }}
                  </b-form-checkbox>
                </template>
                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group class="check" v-model="departamentoSelected" :options="departamentos" name="departamento_selected" :aria-describedby="ariaDescribedby"></b-form-checkbox-group>
                </template>
              </b-form-group>            
            </b-tab>
          </b-tabs>
        </div>
      </div>  
      
      <div class="row">
        <div class="col-12 text-center">
          <b-alert variant="success" show> {{$t('involucrados_encontraron_alert_1')}} {{ involucradosByFilter.length }} {{$t('involucrados_encontraron_alert_2')}} </b-alert>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <b-tabs content-class="mt-3">
            <b-tab :title="$t('plan_region_grafico')">
              <div class="row">
                <div class="col-12">
                  <graficosInvolucrados :dataset="filteredData"></graficosInvolucrados>
                </div>
              </div>
            </b-tab>
            <b-tab :title="$t('involucrados_region_lista')" active>
              <div class="row">
                <div class="col-12">
                  <div class="row border-bottom regente-plan-item planes-results pt-3 pb-3" :key="actor.nombre" v-for="actor in involucradoResultados">            

                    <div class="col-12 col-md-4 mb-3" >
                      <h5>{{ actor.nombre }}</h5>
                      <div class="grupos">
                        <label class="label-planes">{{$t('involucrados_opero')}}</label>
                      {{ actor.grupos }}                     
                      </div>
                    </div>
                    <div class="col-4 col-md-3 mb-3" >              
                      <label class="label-planes">{{$t('involucrados_participo')}}</label>
                        <h5>{{ actor.planes }} {{$t('involucrados_h5')}}</h5>          
                    </div>
                    <div class="col-8 col-md-3 mb-3" >              
                      <label class="label-planes">{{$t('involucrados_red_influ')}}</label>
                      <ul class="departamentos">
                        <li :key="d" v-for="d in actor.departamentos">
                          {{ d }}
                        </li>                        
                      </ul>
                    </div>
                    <div class="col-12 col-md-2 align-self-center">
                      
                      <router-link :to="{ name: 'InvolucradoPage', params:{ id: actor.url}}" class="btn" >{{$t('involucrados_perfil')}}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab class="excel_button" disabled>
              <template #title>
                <div class="download_excel_button">
                  <download-excel :data="involucradoResultados" :fields="field_export">
                    <font-awesome-icon icon="file-download"/>{{$t('involucrados_descarga')}}          
                  </download-excel>
                </div>                
              </template>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import BuscadorMenu from '../components/BuscadorMenu.vue'
import graficosInvolucrados from '../components/graficosInvolucrados.vue'
import slugify from 'slugify'
import { find, filter, groupBy, map, uniq, sum, orderBy } from "lodash"


export default {
  name: 'Involucrados',
  props: {
    dataset: Array
  },
  components: {      
    graficosInvolucrados,
    BuscadorMenu
  },
  data() {
    return {
      field_export: {
        "Nombre completo": "nombre",
        "Cantidad de planes": "planes",
        "Ha participado como": "grupos",
        "Departamentos de influencia": "departamentos",
        "URL": {
          field: "url",
          callback: (value) => {
            return `https://maderalegal.pe/#${value}`
          },
        }
      },
      yearSelected: [2010, 2011, 2012],
      filterBy: ['consultor_pmf_id'],
      modalidadSelected: ['concesión_forestal_maderable', 'permiso_forestal_en_predio_privado'],
      departamentoSelected: ['LORETO'],
      filters: [
        {value: "consultor_pmf_id", text: this.$t('consultor_pmf_id')},
        {value: "profesional_inf_tecnico_insp_ocular_id", text: this.$t('profesional_inf_tecnico_insp_ocular_id')},
        {value: "profesional_recomienda_aprueba_pmf_id", text: this.$t('profesional_recomienda_aprueba_pmf_id')},
        {value: "funcionario_aprobo_pmf_id", text: this.$t('funcionario_aprobo_pmf_id')},
        {value: "representante_legal_id", text: this.$t('representante_legal_id')},
        {value: "titular_actual", text: this.$t('titular_actual')}
      ]
    }
  },
  methods: {
    get_slug(involucrado) {
      return (slugify(involucrado)).toLowerCase()
    },
    get_label(involucrado) {
      return find(this.filters, ['value', involucrado])
    },
    toggleAll(checked) {
      this.filterBy = checked ? map(this.filters, "value").slice() : []
    },
    toggleModalidad(checked) {
      this.modalidadSelected = checked ? map(this.modalidad, "value").slice() : []
    },
    toggleDep(checked) {
      this.departamentoSelected = checked ? this.departamentos.slice() : []
    }
  },
  computed:{
    departamentos() {
      return uniq(map(this.dataset, 'departamento'))
    },
    modalidad() {
      let subset=map(this.dataset,'modalidad').sort()

      return map(uniq(subset), m => {
        return {
          text: this.$t(m),
          value: m
        }
      })
    },
    filteredData() {
      return filter(this.dataset, item => {
        if(this.modalidadSelected.includes(item.modalidad) && this.departamentoSelected.includes(item.departamento)) {
          return item
        }
      })
    },
    involucradosByFilter() {
      let results = map(this.filterBy, f => {
        console.log(this.filteredData)
        let dataFiltered = filter(this.filteredData, item => ((item[f] != 'nd' && item[f] != '*No indica' )&& (item[f] && item[f].typeof !== 'undefined' && item[f] !== '-')))
        return map(groupBy(dataFiltered, f), (rows, id) => {
          return {
            id: id,
            nombre: uniq(map(rows, f.replace("_id", ""))).join(""),
            planes: rows.length,
            departamentos: uniq(map(rows, 'departamento')),
            grupo: this.get_label(f).text
          }
        })
      })

      return [].concat.apply([], results)
    },
    involucradoResultados() {
      return orderBy(map(groupBy(this.involucradosByFilter, 'nombre'), item => {
        return {
          nombre: uniq(map(item, 'nombre')).join(""),
          planes: sum(map(item, 'planes')),
          roles: uniq(map(item, 'grupo')).length,
          grupos: uniq(map(item, 'grupo')).join(", "),
          departamentos: uniq([].concat.apply([], map(item, 'departamentos'))),
          url: `${this.get_slug(uniq(map(item, 'nombre')).join(""))}`,
        }
      }), ['planes', 'roles', 'departamentos'], ['desc', 'desc', 'departamentos'])
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
